import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import { notification } from "antd";
import { getToken } from "../../utils/utility";
import { getLogsRequest } from "../../services/logsHistoryServices";

export function* getAllLogs({ startDate, endDate }) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(getLogsRequest, token, startDate, endDate);
    if (response[0] === 200) {
      let key = 1;
      yield put({
        type: actions.GET_LOGS_SUCCESS,
        logsHistory: response[1].map((x) => ({ ...x, key: key++ })),
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      notification["error"]({
        message: "Грешка",
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export default function* rootSaga() {
  yield all([yield takeEvery(actions.GET_LOGS_REQUEST, getAllLogs)]);
}
